import { PaginationProps } from 'antd';
import { FC, memo, useCallback, useState } from 'react';

import { Domain, DomainConfigCreateMultiForm } from '@/modules/Domains';

import { DomainsMultiConfigurationModalView } from './DomainsMultiConfigurationModalView';

interface Props {
  domains: Pick<Domain, 'id' | 'name' | 'isConfigured'>[];
  pagination: PaginationProps;
  checkedDomains: string[];
  configureMultiDomainsLoading: boolean;
  handleCheckDomain: (id: string) => void;
  handleClearCheckedDomains: () => void;
  handleCloseModal: () => void;
  handleChangeModalWidth: (step: number) => void;
}

export const DomainsMultiConfigurationModalStepsView: FC<Props> = memo(
  ({
    domains,
    pagination,
    checkedDomains,
    configureMultiDomainsLoading,
    handleCheckDomain,
    handleCloseModal,
    handleClearCheckedDomains,
    handleChangeModalWidth,
  }) => {
    const [step, setStep] = useState(1);

    const handleNextStep = useCallback(() => {
      setStep(2);
      handleChangeModalWidth(2);
    }, []);

    const handlePrevStep = useCallback(() => {
      setStep(1);
      handleChangeModalWidth(1);
    }, []);

    return (
      <>
        {step === 1 && (
          <DomainsMultiConfigurationModalView
            domains={domains}
            pagination={pagination}
            configureMultiDomainsLoading={configureMultiDomainsLoading}
            checkedDomains={checkedDomains}
            handleContinue={handleNextStep}
            handleCheckDomain={handleCheckDomain}
            handleClearCheckedDomains={handleClearCheckedDomains}
          />
        )}

        {step === 2 && (
          <DomainConfigCreateMultiForm
            domainIds={checkedDomains}
            handleCloseModal={handleCloseModal}
            handleBack={handlePrevStep}
          />
        )}
      </>
    );
  },
);
